var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildshapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 166,
    viewBox: "0 0 576 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 2 166)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 84 166)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 166 166)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 248 166)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    transform: "matrix(1 0 0 -1 330 166)",
    fill: "#43A047",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 166 84)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    transform: "matrix(1 0 0 -1 248 84)",
    fill: "#9BB7FF",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 330 84)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 412 84)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 494 84)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 412 166)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 82,
    height: 82,
    transform: "matrix(1 0 0 -1 494 166)",
    stroke: "#424242",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 162,
    height: 82,
    rx: 41,
    transform: "matrix(1 0 0 -1 2 82)",
    fill: "#43A047",
    stroke: "#424242",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildshapes);
export default __webpack_public_path__ + "static/media/buildshapes.5bfd98dcfabff8fa49788df04fdf7b53.svg";
export { ForwardRef as ReactComponent };